import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, SERVICES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'service',
  url: `${SERVICES_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
